import { render, staticRenderFns } from "./PrescricaoDietaIcon.vue?vue&type=template&id=08942e9e"
import script from "./PrescricaoDietaIcon.vue?vue&type=script&lang=js"
export * from "./PrescricaoDietaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports